import { useHistory } from "react-router-dom"
import PickingAction from "components/OrderDetail/ProcessProducts/PickingAction"
// import ProcessedItemRow from "../../../components/ProcessedItemRow/ProcessedItemRow"
import ProcessProductsList from "components/OrderDetail/ProcessProducts/ProcessProductsList"
import AlertStyled from "theme/common/Alert.styled"
import UseConfirmOrder from "./useConfirmOrder"
import { IProcessItem } from "interfaces/IItemsOrder"
import OrderDetailHOC from "hoc/OrderDetailHOC"
import { OrderDetailType } from "types/OrderType"
import SummaryProductList from "components/OrderDetail/SummaryProducts/SummaryProductsList"
import { LinkIconStyled } from "theme/common/Link.styled"
import { IconArrowOutlineRigth, IconBackArow, IconCancel } from "theme/common/Icon.styled"
import { ButtonStyled } from "theme/common/Button.styled"
import ContentDetailOrderActionsStyled from "theme/common/ContentDetailOrderActions.styled"
import UseCancelOrder from "hooks/UseCancelOrder"
import useCancelDecreaseOrder from "hooks/UseCancelDecreaseOrder"
import useHideActionButtons from "hooks/UseHideActionButtons"
import { EShippinggroupAction } from "enums/shippinggroupEmun"
import { useEffect, useState, Suspense, useContext, useRef } from "react"
import Checkbox from "components/Commons/CheckBox"
import { AuthContext } from "context/context/AuthContext"
import { clients } from "webapp-clients/Clients"
import { useGetCancelActionByClient } from "hooks/UseGetMultiClient"
import ProductItemRow from "./ProductItemRow"
import ScannerItems from "../../../components/ProductScanner/ScannerItems"
import Modal from "components/Commons/Modal/Modal"
import styled from "styled-components"

const ProductListGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
  margin-top: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`

const CancelModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  text-align: center;
  background-color: ${({ theme }) => theme.palette.white};
  padding: 2rem;
  border-radius: 8px;
  h3 {
    margin: 0;
  }
  p {
    margin: 0;
    color: ${({ theme }) => theme.palette.grey80};
  }
  .actions {
    display: flex;
    gap: 1rem;
    margin-top: 0.5rem;
    button {
      flex: 1;
      justify-content: center;
    }
  }
`

const CancelAlertModalContent = styled(CancelModalContent)`
  border: 2px solid #d32f2f;
  h3 {
    color: #d32f2f;
  }
  p {
    color: #b71c1c;
    font-weight: 500;
  }
  .danger-btn {
    background-color: #d32f2f;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 0.7rem 1.2rem;
    flex: 1;
    font-size: 1rem;
    cursor: pointer;
    font-weight: 600;
    &:hover {
      background-color: #b71c1c;
    }
  }
  .cancel-btn {
    background-color: transparent;
    color: #555;
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 0.7rem 1.2rem;
    flex: 1;
    font-size: 1rem;
    cursor: pointer;
    &:hover {
      background-color: #f5f5f5;
    }
  }
`

const ConfirmOrderScreen = ({
  order,
  shippinGroupDetail,
  shippingGroupId,
  setFinishedShippingGroupAction,
  finishedShippingGroupAction,
}: OrderDetailType) => {
  const { hideConfirmActions, updateVisibilityButtonActions } = useHideActionButtons()

  const {
    state: { user },
  } = useContext(AuthContext)

  useEffect(() => {
    updateVisibilityButtonActions(shippinGroupDetail?.source?.id, shippinGroupDetail?.target?.source?.id)
  }, [shippinGroupDetail, updateVisibilityButtonActions])

  const history = useHistory()

  const itemsOrder = shippinGroupDetail?.source.items

  const [checkedNoLocker, setCheckedNoLocker] = useState(false)

  const handleChageNoLocker = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedNoLocker(!checkedNoLocker)
  }

  const [permissionOrder, actionOrder] = useGetCancelActionByClient()

  const handleClickCancel = () => {
    handleClickCancelOrder(actionOrder)
  }

  const {
    // itemsAllProcessed,
    loadingConfirm,
    handleClickConfirmOrder,
    backToScan,
    dispachPickingTransition,
    pickingTransition,
    canIuseLocker,
  } = UseConfirmOrder({
    order,
    shippinGroupDetail,
    itemsOrder,
    shippingGroupId,
    checkedNoLocker,
    setFinishedShippingGroupAction,
  })

  const { handleClickCancelOrder, loadingCancel, canIuseCancel } = UseCancelOrder({
    order,
    shippingGroupId,
    permissionOrder,
  })

  const { handleClickCancelDecreaseOrder, loadingCancelDecrase, canIuseCancelDecraese } = useCancelDecreaseOrder({
    order,
    shippingGroupId,
  })

  const modalCancelRef = useRef<any>(null)
  const modalCancelConfirmRef = useRef<any>(null)

  const handleClickCancelFlow = () => {
    modalCancelRef.current?.open()
  }
  const confirmCancel = () => {
    modalCancelRef.current?.close()
    // Abrir segundo diálogo de alerta roja
    modalCancelConfirmRef.current?.open()
  }
  const confirmCancelFinal = () => {
    modalCancelConfirmRef.current?.close()
    handleClickCancel()
  }

  const modalCancelDecreaseRef = useRef<any>(null)
  const handleClickCancelDecreaseFlow = () => {
    modalCancelDecreaseRef.current?.open()
  }
  const confirmCancelDecrease = () => {
    modalCancelDecreaseRef.current?.close()
    handleClickCancelDecrease()
  }

  const processedQuantities = (pickingTransition.processItems as IProcessItem[]).reduce(
    (acc: Record<string, number>, item) => {
      acc[item.sku] = (acc[item.sku] || 0) + (item.quantity || 1)
      return acc
    },
    {},
  )

  const displayPendingItems =
    itemsOrder
      ?.map((item) => {
        const processed = processedQuantities[item.sku] || 0
        const pending = (item.quantity || 1) - processed
        return { ...item, quantity: pending }
      })
      .filter((item) => (item.quantity || 0) > 0) || []

  // const remainingItemsForScanner =
  //   itemsOrder?.filter((item) => {
  //     const processed = processedQuantities[item.sku] || 0
  //     return processed < (item.quantity || 1)
  //   }) || []

  // Replaces the old remainingItems filter
  const itemsAllProcessedOverride = displayPendingItems.length === 0

  // Todos los productos están rechazados: todos procesados y ninguno confirmado
  const allProductsRejected =
    itemsOrder &&
    itemsOrder.length > 0 &&
    itemsAllProcessedOverride &&
    !pickingTransition.processItems.some((pItem: IProcessItem) => pItem.isConfirm === true)

  // Botón Cancelar - Estilo personalizado Gris Oscuro
  const CancelOrderBtn = styled(ButtonStyled)`
    background-color: #333 !important;
    border-color: #333 !important;
    color: #fff !important;
    min-width: 240px;
    height: 48px;
    border-radius: 8px;
    font-weight: 600;
    &:hover {
      background-color: #222 !important;
      border-color: #222 !important;
    }
  `

  const DestructiveBtn = styled(ButtonStyled)`
    background-color: #d32f2f !important;
    border-color: #d32f2f !important;
    color: #fff !important;
    &:hover {
      background-color: #b71c1c !important;
      border-color: #b71c1c !important;
    }
  `

  //events
  const handleClickProcessProduct = (item: IProcessItem) => {
    if (item) {
      if (pickingTransition.isEditing) {
        const nextItemIndex = itemsOrder?.findIndex(
          (item) => !pickingTransition.processItems.some(({ sku }) => sku === item.sku),
        )
        dispachPickingTransition({
          type: "EDIT_ITEM_SERIES",
          payload: {
            itemEdit: item,
            nextItemIndex: nextItemIndex || -1,
          },
        })

        return
      }
      dispachPickingTransition({ type: "ADD_PROCESS_ITEM", payload: item })
    }
  }

  const handleClickBackToScan = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    backToScan()
  }
  // const handleClickEdit = (sku: string) => {
  //   dispachPickingTransition({ type: "CHANGE_ITEM_ACTIVE_FOR_EDIT", payload: sku })
  // }

  const handleClickCancelDecrease = () => {
    handleClickCancelDecreaseOrder(EShippinggroupAction.cancel_decrease)
  }

  const client = clients[user?.mainGroup.id as keyof typeof clients]
  const ContentFileMedia = client["ContentFileMedia" as keyof typeof client]

  const files = shippinGroupDetail?.status
    .filter(({ media }) => media)
    .flatMap(({ media }) => media?.ref.map(({ id }) => id))

  // Al menos un producto confirmado
  const atLeastOneConfirmed = pickingTransition.processItems.some((pItem: IProcessItem) => pItem.isConfirm === true)

  return (
    <>
      {!finishedShippingGroupAction ? (
        <>
          {itemsAllProcessedOverride && (
            <LinkIconStyled to="#" className="padding-content" onClick={handleClickBackToScan}>
              <IconBackArow />
              <span>Regresar</span>
            </LinkIconStyled>
          )}

          {!itemsAllProcessedOverride && itemsOrder && !hideConfirmActions && (
            <div style={{ maxWidth: "400px", padding: "1rem", margin: "0 auto" }}>
              <ScannerItems remainingItems={displayPendingItems} onClicProcessProduct={handleClickProcessProduct} />
            </div>
          )}
          <AlertStyled variant="default">
            <p>Para continuar, necesita escanear todos los productos</p>
          </AlertStyled>

          {!itemsAllProcessedOverride && displayPendingItems && (
            <ProductListGrid>
              {displayPendingItems.map((item, index) => (
                <ProductItemRow
                  key={item.sku + index}
                  itemOrder={item}
                  onClicProcessProduct={handleClickProcessProduct}
                  allOrderItems={itemsOrder}
                  source={shippinGroupDetail?.source.id}
                  hideConfirmActions={hideConfirmActions}
                  pickingTransition={pickingTransition}
                  dispachPickingTransition={dispachPickingTransition}
                />
              ))}
            </ProductListGrid>
          )}

          {canIuseLocker && (
            <div className="box-checkbox">
              <Checkbox
                id="noLocker"
                name="noLocker"
                onChange={handleChageNoLocker}
                checked={checkedNoLocker}
                label="No asignar locker"
              />
            </div>
          )}

          {pickingTransition.processItems.length > 0 && (
            <div style={{ marginTop: "1rem" }}>
              <AlertStyled variant="info">Productos Procesados</AlertStyled>
              <ProcessProductsList processItems={pickingTransition.processItems} />
            </div>
          )}

          {/* The SummaryProductList for nextItems has been removed as all items are now displayed in the main list. */}

          {ContentFileMedia && files && files.length > 0 && (
            <Suspense fallback={null}>
              <ContentFileMedia listIdFiles={files} shippingGroupId={shippingGroupId} />
            </Suspense>
          )}

          {canIuseCancel && !hideConfirmActions && allProductsRejected && (
            <ContentDetailOrderActionsStyled style={{ marginTop: "2rem", maxWidth: "400px", margin: "0 auto" }}>
              <CancelOrderBtn
                variant="secondary"
                onClick={handleClickCancelFlow}
                loadingButton={loadingCancel}
                disabled={loadingCancel}
              >
                <IconCancel />
                <span>Cancelar Orden</span>
              </CancelOrderBtn>
            </ContentDetailOrderActionsStyled>
          )}

          {canIuseCancelDecraese && !hideConfirmActions && (
            <ContentDetailOrderActionsStyled>
              <CancelOrderBtn
                variant="secondary"
                onClick={handleClickCancelDecreaseFlow}
                loadingButton={loadingCancelDecrase}
                disabled={loadingCancelDecrase}
              >
                <IconCancel />
                <span>Cancelar Orden (Sin Stock)</span>
              </CancelOrderBtn>
            </ContentDetailOrderActionsStyled>
          )}

          {itemsAllProcessedOverride && atLeastOneConfirmed && (
            <div style={{ maxWidth: "400px", margin: "0 auto" }}>
              <PickingAction loadingConfirm={loadingConfirm} onClickConfirmOrder={handleClickConfirmOrder} />
            </div>
          )}
        </>
      ) : (
        <>
          <div className="padding-content">
            <ButtonStyled
              variant="primary"
              fullSize={true}
              onClick={() => history.push(`/order/package/${shippingGroupId}/${shippinGroupDetail?.orderId}`)}
            >
              <span>Ir a empacar</span>
              <IconArrowOutlineRigth />
            </ButtonStyled>
          </div>
          <SummaryProductList itemsOrder={pickingTransition.processItems} groupPicking={true} />
        </>
      )}

      <Modal ref={modalCancelRef}>
        <CancelModalContent>
          <h3>¿Está seguro que desea cancelar la orden?</h3>
          <p>Esta acción no se puede deshacer. La orden será cancelada completamente.</p>
          <div className="actions">
            <ButtonStyled variant="secondary" onClick={() => modalCancelRef.current?.close()}>
              <span>Volver atrás</span>
            </ButtonStyled>
            <DestructiveBtn variant="primary" onClick={confirmCancel}>
              <span>Confirmar Cancelación</span>
            </DestructiveBtn>
          </div>
        </CancelModalContent>
      </Modal>

      <Modal ref={modalCancelConfirmRef}>
        <CancelAlertModalContent style={{ backgroundColor: "rgba(255, 235, 235, 0.98)" }}>
          <h3>🚨 Reconfirmación de cancelación</h3>
          <p>
            ¿Está completamente seguro? Esta acción es <strong>irreversible</strong> y la orden será cancelada
            definitivamente.
          </p>
          <div className="actions">
            <button className="cancel-btn" onClick={() => modalCancelConfirmRef.current?.close()}>
              Volver
            </button>
            <button className="danger-btn" onClick={confirmCancelFinal}>
              Sí, cancelar orden
            </button>
          </div>
        </CancelAlertModalContent>
      </Modal>

      <Modal ref={modalCancelDecreaseRef}>
        <CancelModalContent>
          <h3>Cancelar Orden sin Modificar Inventario</h3>
          <p>
            ¿Estás seguro que deseas cancelar? <br />
            Los cambios no guardados se perderán.
          </p>
          <div className="actions">
            <ButtonStyled variant="secondary" onClick={() => modalCancelDecreaseRef.current?.close()}>
              <span>Volver atrás</span>
            </ButtonStyled>
            <DestructiveBtn variant="primary" onClick={confirmCancelDecrease}>
              <span>Confirmar</span>
            </DestructiveBtn>
          </div>
        </CancelModalContent>
      </Modal>
    </>
  )
}

export default OrderDetailHOC(ConfirmOrderScreen)
